import CookieSettings from './Components/CookieSettings';
import CookieNotice from './Components/CookieNotice';

function init() {
    const cookieSettings = new CookieSettings();
    const cookieNotice = new CookieNotice();

    cookieSettings.init();
    cookieNotice.init();
}

export default {
    init
}


// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieConsent/index.js